export const appSessionData = 'appSessionData';
export const displayDefaultChannel = 'default';
export const icaUrl = 'configurationdetails';
export const detailsPage = 'details';

export const PunchoutApi = {
  Clone: '/punchout/v1/configuration/clone',
  Search: '/punchout/v1/configuration/search',
  Diff: '/punchout/v1/configuration/diff',
  ReadImage: '/product/v1/images/read',
  GetUser: '/user/v1/details',
  Configure: 'punchout/v1/configuration/configure',
  ProductInfo: 'punchout/v1/product/info/read',
};

export const UserApi = {
  GetUser: '/user/v1/details',
};

export const ProductApi = {
  ReadImage: '/product/v1/images/read',
};

export const DiffColumns = {
  option: [{ field: 'optionCode' }, { field: 'oldValue' }, { field: 'newValue' }],
  property: [{ field: 'propertyCode' }, { field: 'oldValue' }, { field: 'newValue' }],
};

export const popperModifier = [
  {
    name: 'flip',
    enabled: false,
    options: {
      altBoundary: false,
      rootBoundary: 'viewport',
    },
  },
  {
    name: 'preventOverflow',
    enabled: true,
    options: {
      altAxis: true,
      altBoundary: true,
      tether: true,
      rootBoundary: 'document',
    },
  },
];

export enum EUrlParams {
  ConfigurationId = 'cid',
  Scope = 'cc',
  PackagePath = 'packagePath',
  ProductModel = 'productModel',
  Channel = 'C',
  Release = 'R',
}

export enum HiddenSection {
  Hidden = 'hidden',
  Scope = 'Scope',
}

export enum ESalesTextType {
  Long = 'long',
  Short = 'short',
}

export enum EColumns {
  FeatureFamilyCode = 'featureFamilyCode',
  OptionCode = 'optionCode',
  FeatureAction = 'featureAction',
  OptionAction = 'optionAction',
}

export enum EDiffAction {
  Modified = 'modified',
  Deleted = 'deleted',
  Added = 'added',
}

export enum EProperty {
  Optional = 'OPT',
}

export enum EMessageType {
  Error = 'error',
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
}

export enum EView {
  CPQ = 'CPQ',
  ESTORE = 'ESTORE',
  MASTER = 'MASTER',
}

export enum ETabValue {
  SalesText = 'SalesText',
  ProductImages = 'ProductImages',
}
